'use client'

import { styled, Theme, useTheme } from '@mui/material'
import React, { ReactNode, useEffect, useMemo, useState } from 'react'

export const RootStyles = (
  theme: Theme,
  width: number,
  height?: string | number,
) => {
  return {
    height: height || '100%',
    color: '#fff',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      // Below 600px
      padding: theme.spacing(4),
    },
    [theme.breakpoints.up('sm')]: {
      // Below 600px
      padding: theme.spacing(8),
    },
    [theme.breakpoints.up('md')]: {
      // Above 900px
      padding: theme.spacing(12),
    },
    [theme.breakpoints.up('lg')]: {
      // Above 1200px
      padding: theme.spacing(16),
    },

    [theme.breakpoints.up('xl')]: {
      // Above 1560px
      padding: `${theme.spacing(16)} ${theme.spacing((width / 2) * 0.05)}`,
    },
  }
}

function RootPageContainer({
  height,
  children,
  styles,
  useBackground,
}: {
  height?: string | number
  children: ReactNode
  styles?: any
  useBackground?: string
}) {
  const theme = useTheme()
  const [width, setWidth] = useState<undefined | number>()
  const rootStyles = useMemo(
    () => RootStyles(theme, width, height),
    [theme, width, height],
  )

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth)
    }

    setWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const background = !useBackground
    ? {
        background:
          'linear-gradient(180deg, rgb(12,13,16) 30%, rgba(10,10,10,1) 60%, rgba(0,0,0,1) 91%);',
      }
    : {}

  const Root = styled('div', { label: 'Root' })(() => ({
    ...rootStyles,
    ...background,
    ...styles,
  }))

  return (
    <Root className="root-page" data-background={useBackground}>
      {children}
    </Root>
  )
}

export default RootPageContainer
